import store from '../../store'
import {
  AUTO_TIER,
  BIKE_TIER,
  FREIGHT_TIER,
  PED_NETWORK,
  PED_TIER,
  ST_NAME,
  ST_TYPE,
  TRANSIT_TIER
} from '../constants/layerFieldNames'
import {
  ADD_FEATURE_TO_PROJECT,
  REMOVE_FEATURE_FROM_PROJECT
} from '../constants/popup'
import { ADD } from '../constants/segmentSelectionToolbox'
import { selectFeatureFromMap } from '../controller/esriMapController'
import { setDrawerOpen } from '../slices/mainTool'

export const appConfig = {
  mapServerURL:
    'https://gis.semcog.org/server/rest/services/Multi_Modal_Tool_Data/MapServer/'
}

const popupTitle = `{${ST_NAME}} {${ST_TYPE}}`
const popupFieldsContent = {
  type: 'fields',
  fieldInfos: [
    {
      fieldName: 'expression/st-name-arcade'
    },
    {
      fieldName: 'Context2',
      label: 'Land Use Context'
    },
    {
      fieldName: 'expression/ped-tier-arcade'
    },
    {
      fieldName: 'expression/bike-tier-arcade'
    },
    {
      fieldName: 'expression/transit-tier-arcade'
    },
    {
      fieldName: 'expression/auto-tier-arcade'
    },
    {
      fieldName: 'expression/freight-tier-arcade'
    }
  ]
}
const arcadeExpressionInfos = [
  // Get Arcade expression returning the predominant demographic in the county:
  // Whether the majority of people are in the labor force or not
  {
    name: 'st-name-arcade',
    title: 'Street Name',
    expression: `$feature.${ST_NAME} + ' ' + $feature.${ST_TYPE}`
  },
  {
    name: 'ped-tier-arcade',
    title: 'Pedestrian',
    expression: `if(!isEmpty($feature.${PED_TIER})) { return 'Tier' + ' '  + $feature.${PED_TIER} }else{ return 'N/A'}`
  },
  {
    name: 'bike-tier-arcade',
    title: 'Bicycle',
    expression: `if(!isEmpty($feature.${BIKE_TIER})) { return 'Tier' + ' '  + $feature.${BIKE_TIER} }else{ return 'N/A'}`
  },
  {
    name: 'transit-tier-arcade',
    title: 'Transit',
    expression: `if(!isEmpty($feature.${TRANSIT_TIER})) { return 'Tier' + ' '  + $feature.${TRANSIT_TIER}}else{ return 'N/A'}`
  },
  {
    name: 'auto-tier-arcade',
    title: 'Automobile',
    expression: `if(!isEmpty($feature.${AUTO_TIER})) { return 'Tier' + ' '  + $feature.${AUTO_TIER} }else{ return 'N/A'}`
  },
  {
    name: 'freight-tier-arcade',
    title: 'Freight',
    expression: `if(!isEmpty($feature.${FREIGHT_TIER})) { return 'Tier' + ' '  + $feature.${FREIGHT_TIER} }else{ return 'N/A'}`
  }
]

export const landUsePopupTemplate = {
  title: popupTitle,
  content: [
    popupFieldsContent,

    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const setUpProjectBtn = document.createElement('button')
        setUpProjectBtn.className = 'setup-project-btn'
        setUpProjectBtn.innerHTML = ADD_FEATURE_TO_PROJECT

        setUpProjectBtn.onclick = () => {
          selectFeatureFromMap()
        }

        customContainer.append(setUpProjectBtn)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}
const pedestrianArcadeExpressionInfos = [
  {
    name: 'ped-tier-source-arcade',
    title: 'Facility/Source',
    expression: `if($feature.${PED_NETWORK} == 2 || $feature.${PED_NETWORK} == 3) { return 'Bike & Pedestrian Demand Area'}`
  }
]
export const pedestrianPopupTemplate = {
  title: 'Pedestrian',
  content: [
    {
      type: 'fields',
      fieldInfos: [
        {
          fieldName: PED_NETWORK,
          label: 'Tier'
        },
        {
          fieldName: 'expression/ped-tier-source-arcade'
        }
      ]
    }
  ],
  expressionInfos: pedestrianArcadeExpressionInfos
}
export const landUsePopupTemplateRemoveFeature = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const setUpProjectBtn = document.createElement('button')
        setUpProjectBtn.className = 'setup-project-btn'
        setUpProjectBtn.innerHTML = REMOVE_FEATURE_FROM_PROJECT

        setUpProjectBtn.onclick = () => {
          selectFeatureFromMap()
        }

        customContainer.append(setUpProjectBtn)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}
export const landUsePopupTemplateDiffStName = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const customText = document.createElement('p')
        customText.className = 'err_esri_popup_content'
        customText.innerHTML =
          'You have selected segments with different street names. Please select segments with the same street name as your project.'

        customContainer.append(customText)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}

export const landUsePopupTemplateDiffLanduse = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const customText = document.createElement('p')
        customText.className = 'err_esri_popup_content'
        customText.innerHTML =
          'This segment cannot be added because it has a different land use context than your current project. The Multimodal Tool tests one land use context at a time. If your street runs through multiple land use contexts, you can set up a different project for each.'
        customContainer.append(customText)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}
export const landUsePopupTemplateDiffTiers = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const customText = document.createElement('p')
        customText.className = 'err_esri_popup_content'
        customText.innerHTML =
          'This segment cannot be added because it has different modal tiers than your current project. The Multimodal Tool tests one set of modal tiers at a time. If your street runs through multiple tiers, you can set up a different project for each.'
        customContainer.append(customText)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}
export const landUsePopupTemplateNotPartOfProject = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const customText = document.createElement('p')
        customText.className = 'err_esri_popup_content'
        customText.innerHTML =
          'You are trying to remove a segment that is not part of your project. Segments must be added to the project before they can be removed.'
        customContainer.append(customText)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}

export const landUsePopupTemplateAlreadyPartOfProject = {
  title: popupTitle,
  content: [
    popupFieldsContent,
    {
      type: 'custom',
      outFields: '*',
      creator: () => {
        const customContainer = document.createElement('div')
        customContainer.className = 'custom_popup_content__container'
        const customText = document.createElement('p')
        customText.className = 'err_esri_popup_content'
        customText.innerHTML =
          'This segment is already part of your project. You can remove it by selecting “Remove” from the toolbox window.'
        customContainer.append(customText)

        return customContainer
      }
    }
  ],
  expressionInfos: arcadeExpressionInfos
}
